import { Outlet } from "react-router-dom";

import NavMenu from "~/common/components/ui/NavMenu";
import { HeaderInfo } from "~/patients/components/home";
import { useGetCurrentPatient } from "~/patients/hooks/queries/useGetCurrentPatient";
import { useUiStore } from "~/patients/stores";

export const ConsultationHomeLayout = () => {
  const { data: user } = useGetCurrentPatient();
  const { setSideBarOpen } = useUiStore();
  const isInactivePatient = !!user?.organization_patients[0].archived_at;

  const title = user
    ? isInactivePatient
      ? "Your consultation has ended"
      : `Welcome, ${user.name}`
    : "";

  return (
    <div className="relative flex h-screen-calculated w-full flex-col text-sm">
      <NavMenu
        showCurrentProvider
        headerInfo={<HeaderInfo title={title} />}
        handleOpenSideBar={() => setSideBarOpen(true)}
      />
      <Outlet />
    </div>
  );
};
